var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRouteHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-delete",
    clipPath: "url(#clip0_396_5230)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.3332 24.9674C16.4227 24.9674 13.8864 24.2172 11.7242 22.7169C9.56198 21.2165 8.32312 19.3438 8.00761 17.0985H10.6017C10.897 18.8034 11.8727 20.2133 13.5287 21.328C15.1847 22.4428 17.1196 23.0001 19.3332 23.0001C21.8008 23.0001 23.8943 22.332 25.6136 20.9956C27.3329 19.6592 28.1921 18.0323 28.1912 16.1149C28.1912 14.1969 27.3316 12.5697 25.6123 11.2333C23.893 9.89687 21.8 9.229 19.3332 9.22966C17.878 9.22966 16.5176 9.49195 15.2522 10.0165C13.9868 10.5411 12.9217 11.2624 12.057 12.1805H15.5369V14.1477H7.94434V8.24605H10.4752V10.5575C11.5508 9.50834 12.8639 8.69687 14.4145 8.1231C15.9651 7.54933 17.6046 7.26244 19.3332 7.26244C20.915 7.26244 22.3968 7.49621 23.7787 7.96376C25.1605 8.4313 26.3627 9.06212 27.3852 9.85621C28.4076 10.6516 29.2196 11.5861 29.8211 12.6595C30.4226 13.7329 30.723 14.8847 30.7221 16.1149C30.7221 17.3444 30.4214 18.4962 29.8199 19.5703C29.2184 20.6444 28.4068 21.5788 27.3852 22.3736C26.3619 23.1683 25.1597 23.7995 23.7787 24.267C22.3977 24.7346 20.9159 24.968 19.3332 24.9674ZM22.8764 20.246L18.0678 16.5083V11.1969H20.5987V15.7215L24.648 18.869L22.8764 20.246Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_396_5230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.9176,
    height: 24.6836,
    fill: "white",
    transform: "translate(0.747314 0.39444)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteHistory);
export default __webpack_public_path__ + "static/media/route_history.ccce5c8e7b8cadf7ce99bf3607154e52.svg";
export { ForwardRef as ReactComponent };